const h = config => config.height - config.margin.top - config.margin.bottom;

export default h;
